export const getLanguage = () => {
  const languageCode = localStorage.getItem('i18nextLng');

  return {
    languageCode,
    isFrench: languageCode === 'fr',
  };
};

export const getTranslatedItem = (data) => {
  const { languageCode } = getLanguage();
  return data?.find((item) => item.languageCode === languageCode);
};
